import { api } from '../../lib/api';
import type { Weighting } from '../rooms/api';

/**
 * The rules the front page describes.
 *
 * Fetched rather than written into the copy for the same reason the console's
 * queue legend is: a page that hardcodes "×3, five dollars, 80% to the host" is
 * wrong the day somebody changes one of them, and wrong in the most expensive
 * place on the site. See `ExplainAction`.
 */
export interface Explanation {
  weighting: Weighting;
  /** Platform defaults. A host can price their own room; these are the start. */
  boosts: { basic_cents: number; priority_cents: number };
  /**
   * The split, as the one stored number and the processing rate it applies
   * after. The platform's cut is the remainder — see `Payments`.
   */
  revenue: { host_share_bp: number; fee_basis_points: number; fee_fixed_cents: number };
}

export const platform = {
  explain: () => api.get<Explanation>('/explain'),
};
